import { NavLink } from "react-router";
import { cn } from "@core/utils/domUtil";
import type { HTMLAttributes } from "react";

import MenuLink from "@core/components/link/MenuLink";

const clsVariants = {
  pc: {
    depth1: {
      default: cn(`relative block flex h-[var(--pc-header-height)] items-center justify-center py-[18px] px-[10px] text-gray-800 text-center font-medium tracking-[-1px]`, `header-xl:text-[18px]`, `before:bg-point-600 before:transition-width before:absolute before:bottom-0 before:left-[50%] before:h-[4px] before:w-0 before:duration-200 before:ease-in-out`, `after:bg-point-600 after:transition-width after:absolute after:right-[50%] after:bottom-0 after:h-[4px] after:w-0 after:duration-200 after:ease-in-out `, `hover:text-point-600`),
      active: "text-point-600 before:w-[50%] after:w-[50%]",
    },
    depth2: {
      default: "text-md text-gray-800 header-xl:text-lg font-medium tracking-[-0.72px] hover:border-b-1 hover:border-dotted",
      active: "text-point-600",
    },
  },
  mobile: {
    depth1: {
      default: "relative block h-[46px] px-[6px] mx-[10px] py-[12px] text-lg whitespace-nowrap text-gray-800",
      active: "font-medium after:bg-gray-800 after:absolute after:bottom-0 after:left-0 after:h-[2px] after:w-full",
    },
    depth2: {
      default: "relative h-[46px] block mx-[10px] py-[13px] text-md whitespace-nowrap text-gray-800",
      active: "text-point-600 after:bg-point-600 after:absolute after:bottom-0 after:left-0 after:h-[2px] after:w-full",
    },
  },
};

export default function CnbLink({
  type,
  depth,
  data,
  isActive = false,
  ...props
}: {
  type: "pc" | "mobile";
  depth: "depth1" | "depth2";
  data: { url: string; name: string; target?: string };
  isActive?: boolean;
} & HTMLAttributes<HTMLElement>) {
  if (data?.url && data?.target !== "_blank") {
    return <MenuLink {...{ ...data, ...props }} className={cn(clsVariants[type][depth]["default"], isActive && clsVariants[type][depth]["active"])} />;
  } else {
    return <MenuLink {...{ ...data, ...props }} className={cn(clsVariants[type][depth]["default"])} />;
  }
}
